import { z } from "zod";

/** `?filter=` on the bills list (the home figures link here) and an optional supplier. */
export const billsSearch = z.object({
  filter: z.enum(["all", "draft", "unpaid", "overdue", "paid", "no-einvoice"]).catch("all"),
  supplier: z.string().min(1).optional().catch(undefined),
});
export type BillsFilter = z.infer<typeof billsSearch>["filter"];

export const billSearch = z.object({
  tab: z.enum(["details", "journal", "evidence", "activity"]).catch("details"),
});
export type BillTab = z.infer<typeof billSearch>["tab"];

export const paymentsSearch = z.object({
  tab: z.enum(["waiting", "released", "settled", "all"]).catch("waiting"),
});
export type PaymentsTab = z.infer<typeof paymentsSearch>["tab"];

/** A new payment, for a supplier and optionally with one of their credits ticked. */
export const newPaymentSearch = z.object({
  supplier: z.string().min(1).optional().catch(undefined),
  credit: z.string().min(1).optional().catch(undefined),
});
